// extracted by mini-css-extract-plugin
export default {"footerCustom":"Footer_footerCustom__uaqdT","socialLinks":"Footer_socialLinks__t9V22","socialLink":"Footer_socialLink__hs9sR"};